const LoadingMeal = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="flex flex-col items-center">
        <div className="w-52 h-52">
          <img
            src={`${process.env.PUBLIC_URL}/lo.gif`}
            alt="Loading"
            className="w-full h-full object-contain"
          />
        </div>
        <p className="text-slate-200">loading...</p>
      </div>
    </div>
  );
};

export default LoadingMeal;
